import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import BookingForm from '../components/BookingForm';
import FeaturedRoutePromotion from '../components/FeaturedRoutePromotion';
import PopularTaxiRoutes from '../components/PopularTaxiRoutes';
import VehicleFleet from '../components/VehicleFleet';
import Services from '../components/Services';
import SeoHead from '../components/SeoHead';
import { CORE_PAGE_SEO } from '../data/corePageSeo';
import { CUSTOMER_SUPPORT } from '../data/customerPolicies';

import LocalTaxi from '../components/LocalTaxi';
import WhyEasyDropTaxi from '../components/WhyEasyDropTaxi';
import TravelBenefits from '../components/TravelBenefits';
import TravelTerms from '../components/TravelTerms';
import '../styles/home.css';

gsap.registerPlugin(ScrollTrigger);

const locations = [
  "Acharapakkam", "Adirampattinam", "Aduthurai", "Alanganallur", "Alangayam", "Alangudi (Pudukkottai)", "Alangudi (Thiruvarur Dt)", "Alappuzha", "Aliyar", "Ambasamudram", "Ambur", "Ammapet (salem)", "Ammapettai (TJR)", "Anaikatti", "Andimadam", "Andipatti", "Arakkonam", "Arani", "Aranthangi", "Aravakurichi", "Arcot", "Ariyalur", "Arsikere", "Aruppukkottai", "Athani", "Attur", "Auroville", "Avalurpettai", "Avinashi", "Ayyampettai (TJR)", "Badami", "Bagalkot", "Banavara", "Bangalore", "Bangalore Airport", "Bantwal", "Bargur", "Basavakalyan", "Batlagundu", "Belgaum", "Bellary", "Belur", "Bhadravathi", "Bhavani (Erode Dt)", "Bhuvanagiri", "Bidar", "Bodi", "Challakere", "Chamarajanagar", "Channagiri", "Chengalpet", "Chengam", "Chennai", "Chennai Airport", "Chetpet (Thiruvannamalai)", "Cheyyar", "Cheyyur", "Chidambaram", "Chikkaballapur", "Chikmagalur", "Chinna Salem", "Chinnalapatti", "Chinnamanur", "Chitoor", "Cochin", "Coimbatore", "Coonoor", "Courtallam", "Cuddalore", "Cumbum", "Dandeli", "Davanagere", "Denkanikottai", "Devakottai", "Devarsugur", "Devikapuram", "Dhalavaipuram", "Dharapuram", "Dharasuram", "Dharmapuri", "Dharwad", "Dindugal", "Edappadi", "Elampillai", "Ernakulam", "Erode", "Gangaikonda Cholapuram", "Gangavathi", "Gingee", "Gobichettypalayam", "Gokak", "Gokarna", "Gorimedu", "Gudalur", "Gudiyatham", "Gulbarga", "Gumidipoondi", "Guntur", "Guruvayoor", "Hagaribommanahalli", "Hangal", "Harpanahalli", "Harur", "Hassan", "Haveri", "Hogenakkal", "Hosadurga", "Hosur", "Hubli", "Huliyar", "Humnabad", "Hunsur", "Hyderabad", "Jamkhandi", "Jayamkondam", "Jolarpettai", "Kadappa", "Kadayanallur", "Kalahasti", "Kalavai", "Kallakurichi", "Kalpakkam", "Kalugumalai", "Kamuthi", "Kanchipuram", "Kangayam", "Kaniyambadi", "Kannamangalam", "Kannur", "Kanyakumari", "Karaikal", "Karaikudi", "Karkala", "Karur", "Karwar", "Katpadi", "Kattumannarkovil", "Kaveripakkam", "Kaveripattinam", "Kayalpattinam", "Kayathar", "Keelakarai", "Kil Pennathur", "Kodaikanal", "Kodiyakarai", "Kodumudi", "Kolar", "Kollam (Kerala)", "Kollegal", "Komarapalayam", "Koodankulam", "Koothanallur", "Koppal", "Kotagiri", "Kottampatty", "Kottayam", "Kovilpatti", "Kozhikode", "Krishnagiri", "Kudachi", "Kudligi", "Kulasekharapatnam", "Kulithalai", "Kumbakonam", "Kumily", "Kumta", "Kurinjipadi", "Kurnool", "Labbaikudikadu", "Lalgudi", "Madanapalli", "Madikeri", "Madukkur", "Madurai", "Madurantakam (CHN)", "Mahabalipuram", "Mailam", "Manamadurai", "Manamelkudi", "Manampathy", "Manaparai", "Mandapam", "Mannarkudi", "Marakanam", "Marthandam", "Mayiladuthurai", "Mecheri", "Meensurutty", "Melmalayanur", "Melmaruvathur", "Melur (Madurai Dt)", "Melvisharam", "Mettupalayam", "Mettur (salem)", "Mimisal", "Mohanur", "Muddebihal", "Mudhol", "Mudigere", "Munnar", "Murdeshwar", "Musiri", "Muthupet", "Mysore", "Nagapattinam", "Nagercoil", "Naidupeta", "Namakkal", "Nanguneri", "Nannilam", "Natham", "Natrampalli", "Needamangalam", "Nellikkuppam", "Nellore", "Neyveli", "Nilakottai", "Oddanchatram", "Odugathur (Vellore Dt)", "Omalur", "Ongole", "Ooty", "Orathanadu", "Palacode", "Palakad", "Palamaner", "Palani", "Palladam", "Pallikonda", "Pallipattu", "Pamba (Sabarimalai)", "Panruti", "Papanasam (Thanjavur)", "Paramakudi", "Paramathi Velur", "Parangipettai", "Paranur (Villupuram Dt)", "Pattukottai", "Penagaram", "Pennadam", "Pennagaram", "Perambalur", "Peravurani", "Periyakulam", "Pernambut", "Perundurai", "Pichavaram", "Pillayarpatti", "Pochampalli", "Pollachi", "Polur", "Pondicherry", "Ponnamaravathi", "Poompuhar", "Pudukkottai", "Puliyangudi", "Puttaparthi(AP)", "Puttur (AP)", "Puttur (KA)", "Raichur", "Rajapalayam", "Ramanathapuram", "Rameswaram", "Ranebennur", "Ranipet", "Rasipuram", "Rayakottai", "Sagar", "Salem", "Sankagiri", "Sankarankovil", "Sankarapuram", "Sathankulam", "Sathyamangalam", "Sattur", "Sayalgudi", "Sembatti", "Sengottai", "Sethiyathope", "Shikkaripur", "Shivamogga", "Sholavandan", "Sholinghur", "Shorapur", "Singampunari", "Sirkazhi", "Sirsi", "Siruguppa", "Sivagangai", "Sivakasi", "Sricity", "Sriharikota", "Srimushnam", "Sriperumbudhur", "Srirangam", "Srivilliputhur", "Sullerpetai", "Sunguvarchatram", "Swamimalai", "T.Kallupatti", "Tada", "Thalaivasal", "Thammampatti", "Thanjavur", "Tharamangalam", "Tharangambadi", "Thekadi", "Thellar", "Theni", "Thenkasi", "Thennangur", "Thirthahalli", "Thiruchendur", "Thirukadaiyur", "Thirukovillur", "Thirumangalam", "Thirumayam", "Thirunageswaram", "Thirunallar", "Thiruppanandal", "Thiruthuraipoondi", "Thiruvadanai", "Thiruvaiyaru", "Thiruvallur", "Thiruvannamalai", "Thiruvarur", "Thiruvidaimaruthur", "Thiyagadurgam", "Thondi", "Thorapadi", "Thottiyam", "Thrissur, Kerala", "Thuckalay", "Thuraiyur (Trichy)", "Thuvarankuruchi", "Timiri", "Tindivanam", "Tiruchengode", "Tirumala,Tirupati", "Tirunelveli", "Tirupati", "Tirupattur", "Tiruppathur (Sivagangai Dt)", "Tiruppur", "Tiruttani", "Tittakudi", "Toludur", "Trichur", "Trichy", "Trivandrum", "Tuticorin", "Udumalapettai", "Ulundurpettai", "Usilampatti", "Uthangarai", "Uthiramerur", "Vadalur", "Vaitheeswarankoil", "Valliyur", "Valparai", "Vandavasi", "Vaniyampadi", "Vazhapadi", "Vedaranyam", "Vedasandur", "Velankanni", "Vellakoil", "Vellore", "Venkatagiri", "Veppur", "Vettavalam", "Vijayapura", "Vijayawada", "Vikravandi", "Villupuram", "Virajpet", "Viralimalai", "Virudachalam", "Virudhunagar", "Vishakapattinam", "Walajapet", "Walayar", "Wayanad", "Yadgir", "Yelagiri", "Yercaud"
];

const bookingTripType = (value) => {
  const trip = String(value || '').toLowerCase();
  if (trip === 'round' || trip === 'round-trip' || trip === 'roundtrip') return 'Round Trip';
  return 'One Way';
};

const Home = () => {
  const [searchParams] = useSearchParams();
  const initialTripType = bookingTripType(searchParams.get('trip'));
  const [bookingPrefill, setBookingPrefill] = useState({ pickup: '', drop: '', vehicle: '' });
  const homeSeo = CORE_PAGE_SEO.home;
  const homeJsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: homeSeo.title,
        description: homeSeo.description,
        url: 'https://easydroptaxi.com/',
        isPartOf: {
          '@type': 'WebSite',
          name: 'Easy Drop Taxi',
          url: 'https://easydroptaxi.com/',
        },
      },
    ],
    [homeSeo.description, homeSeo.title],
  );

  const prefillHomeBooking = (pickup, drop, vehicle = '') => {
    setBookingPrefill({ pickup, drop, vehicle });
    const target = document.getElementById('home-booking');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleFeaturedFareEstimate = (leg) => {
    prefillHomeBooking(leg.origin, leg.destination, leg.vehicleType || '');
  };

  useEffect(() => {
    if (window.location.hash !== '#home-booking') return undefined;
    const scrollToBooking = () => {
      document.getElementById('home-booking')?.scrollIntoView({ block: 'start' });
    };
    const timer = window.setTimeout(scrollToBooking, 180);
    return () => window.clearTimeout(timer);
  }, [searchParams]);

  useEffect(() => {
    gsap.fromTo('.twm-banner-left-content',
      { opacity: 0 },
      { opacity: 1, duration: 0.7, ease: 'power2.out', delay: 0.15 }
    );

    // ── Section headings: fade up on scroll ──
    gsap.utils.toArray('.section-head').forEach((el) => {
      gsap.fromTo(el,
        { opacity: 0, y: 30 },
        {
          opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%' }
        }
      );
    });

    return () => ScrollTrigger.getAll().forEach(t => t.kill());
  }, []);

  return (
    <main className="page-content">
      <SeoHead
        title={homeSeo.title}
        description={homeSeo.description}
        path={homeSeo.path}
        jsonLd={homeJsonLd}
      />
      {/* BANNER START */}
      <div className="twm-home-1-banner-wrap">
        <div className="twm-home-1-banner">
          <div className="site-hero-stage">
            <picture className="site-hero-picture">
              <source
                media="(min-width: 992px)"
                srcSet="/images/Final.png"
                type="image/png"
              />
              <img
                className="site-hero-photo"
                src="/images/banner/easy-drop-taxi-hero.webp"
                alt="Easy Drop Taxi on the highway"
                fetchPriority="high"
                decoding="async"
              />
            </picture>
            <div className="site-hero-shade" aria-hidden="true" />
            <div className="site-hero-inner">
              <div className="twm-banner-left-content site-hero-copy">
                <h1 className="site-hero-title">Easy Drop Taxi</h1>
                <p className="site-hero-tagline">Book Your Drop Taxi</p>
                <p className="site-hero-rate">₹15/km</p>
                <a
                  className="site-hero-phone"
                  href={CUSTOMER_SUPPORT.phoneTel}
                  aria-label="Call EasyDropTaxi at 9629954544"
                >
                  <i className="fas fa-phone site-hero-phone-icon" aria-hidden="true"></i>
                  <span>9629954544</span>
                </a>
              </div>
            </div>
          </div>

          <section className="home-trip-descriptions" aria-label="Trip types">
            <article className="home-trip-card">
              <h2>One Way Drop</h2>
              <p className="home-trip-card__line home-trip-card__line--primary">Travel to your destination</p>
              <p className="home-trip-card__line">Pay for one way only</p>
            </article>
            <article className="home-trip-card">
              <h2>Round Trip</h2>
              <p className="home-trip-card__line home-trip-card__line--primary">Go, explore, and return</p>
              <p className="home-trip-card__line">Travel with the same cab</p>
            </article>
          </section>

          <div className="twm-banner-search-tabs" id="home-booking">
            <div className="twm-banner-tabs-filter">
              <BookingForm
                locations={locations}
                initialPickup={bookingPrefill.pickup}
                initialDrop={bookingPrefill.drop}
                initialTripType={initialTripType}
                initialVehicle={bookingPrefill.vehicle}
                searchButtonLabel="Get Fare Estimate"
              />
            </div>
            <div className="service-states-ticker" role="region" aria-label="Service availability">
              <div className="service-states-track">
                <p className="service-states-item">
                  Taxi Services <span className="service-states-dot" aria-hidden="true">•</span>
                  Outstation Trips <span className="service-states-dot" aria-hidden="true">•</span>
                  Airport Transfers <span className="service-states-dot" aria-hidden="true">•</span>
                  Tamil Nadu <span className="service-states-dot" aria-hidden="true">•</span>
                  Puducherry <span className="service-states-dot" aria-hidden="true">•</span>
                  Kerala <span className="service-states-dot" aria-hidden="true">•</span>
                  Karnataka <span className="service-states-dot" aria-hidden="true">•</span>
                  Andhra Pradesh
                </p>
                <p className="service-states-item" aria-hidden="true">
                  Taxi Services <span className="service-states-dot" aria-hidden="true">•</span>
                  Outstation Trips <span className="service-states-dot" aria-hidden="true">•</span>
                  Airport Transfers <span className="service-states-dot" aria-hidden="true">•</span>
                  Tamil Nadu <span className="service-states-dot" aria-hidden="true">•</span>
                  Puducherry <span className="service-states-dot" aria-hidden="true">•</span>
                  Kerala <span className="service-states-dot" aria-hidden="true">•</span>
                  Karnataka <span className="service-states-dot" aria-hidden="true">•</span>
                  Andhra Pradesh
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BANNER END */}

      <FeaturedRoutePromotion onGetFareEstimate={handleFeaturedFareEstimate} />

      <PopularTaxiRoutes />

      <LocalTaxi />

      {/* Vehicle Fleet Section */}
      <VehicleFleet />

      {/* Why Easy Drop Taxi Section */}
      <WhyEasyDropTaxi />

      {/* Services Section */}
      <Services />

      <TravelBenefits />

      {/* Google Reviews */}
      <section className="section-full p-t70 p-b60">
        <div className="container">
          <div className="elfsight-app-0ad211a0-222b-4957-8fa8-3a08ae2defe8" data-elfsight-app-lazy></div>
        </div>
      </section>

      {/* Travel Terms */}
      <TravelTerms />
    </main>
  );
};

export default Home;
